if(!customElements.get('filters-footer')) {
  class FiltersFooter extends HTMLElement {
    constructor() {
      super();
      // Internal Elements
      this.clear = this.querySelector('.js-filters-clear');
      this.apply = this.querySelector('.js-filters-apply');
      // External Elements
      this.grid = this.closest('collection-grid');
    }

    /**
     * initClearButton - Initializes the clear button.
     */

    initClearButton() {
      this.clear.addEventListener('click', () => {
        if(!this.grid) return;

        this.grid.removeAll();
      });
    }

    /**
     * initApplyButton - Initializes the apply button.
     */

    initApplyButton() {
      this.apply.addEventListener('click', () => {
        if(!this.grid) return;

        const activeInputs = Array.from(this.grid.querySelectorAll('input')).filter(input => input.checked);
        if(activeInputs.length > 0) this.grid.applyMultiple(activeInputs);

        this.grid?.filters?.closeFilters();
      });
    }

    updateClearButton(enable) {
      if(this.clear) this.clear.toggleAttribute('disabled', !enable);
    }

    updateApplyButton(enable) {
      if(this.apply) this.apply.toggleAttribute('disabled', !enable);
    }

    updateButtons(enable) {
      this.updateClearButton(enable);
      this.updateApplyButton(enable);
    }

    connectedCallback() {
      if(this.clear) this.initClearButton();
      if(this.apply) this.initApplyButton();
    }
  }

  customElements.define('filters-footer', FiltersFooter);
}
